var _path, _path2, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33325 11.5C3.33325 9.61438 3.33325 8.67157 3.91904 8.08579C4.50482 7.5 5.44763 7.5 7.33325 7.5H12.6666C14.5522 7.5 15.495 7.5 16.0808 8.08579C16.6666 8.67157 16.6666 9.61438 16.6666 11.5V11.5C16.6666 14.3284 16.6666 15.7426 15.7879 16.6213C14.9092 17.5 13.495 17.5 10.6666 17.5H9.33325C6.50482 17.5 5.09061 17.5 4.21193 16.6213C3.33325 15.7426 3.33325 14.3284 3.33325 11.5V11.5Z",
    stroke: "#7161BA",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3332 6.66667V5.83333C13.3332 3.99239 11.8408 2.5 9.99984 2.5V2.5C8.15889 2.5 6.6665 3.99239 6.6665 5.83333V6.66667",
    stroke: "#7161BA",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.99992,
    cy: 12.4997,
    rx: 1.66667,
    ry: 1.66667,
    fill: "#7161BA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.e8654ed914f0ee5592f4c213abce4254.svg";
export { ForwardRef as ReactComponent };